<template>
  <div>
    <v-divider v-if="showDivider"/>
    <v-subheader class="">
      <v-icon>
        mdi-map-marker
      </v-icon>
      {{ label }}
      <px-escolher-endereco-dialog :cep="local.cep"
                                   :has-selected-address="hasSelectedAddress"
                                   @change="onSelectAddress"
                                   @clear="onClear"/>
    </v-subheader>
    <v-row dense>
      <v-col cols="3">
        <v-text-field
          dense
          outlined
          hide-details
          disabled
          label="CEP"
          v-mask="['#####-###']"
          class="required"
          :error="$v.local.cep.$error"
          @blur="$v.local.cep.$touch()"
          v-model="local.cep"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          dense
          outlined
          hide-details
          :disabled="hasSelectedAddress"
          label="Logradouro"
          maxlength="100"
          class="required"
          :error="$v.local.logradouro.$error"
          @blur="$v.local.logradouro.$touch()"
          v-model="local.logradouro"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          dense
          outlined
          hide-details
          :disabled="hasSelectedAddress"
          autocomplete="off"
          label="Número"
          maxlength="6"
          v-mask="['######']"
          v-model="local.numero"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="5">
        <v-text-field
          dense
          outlined
          hide-details
          :disabled="hasSelectedAddress"
          autocomplete="off"
          label="Bairro"
          maxlength="60"
          class="required"
          :error="$v.local.bairro.$error"
          @blur="$v.local.bairro.$touch()"
          v-model="local.bairro"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <px-autocomplete-uf outlined
                            hide-details
                            dense
                            disabled
                            class="required"
                            :error="$v.local.uf.$error"
                            @blur="$v.local.uf.$touch()"
                            v-model="local.uf"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <px-autocomplete-municipio
          outlined
          hide-details
          disabled
          dense
          class="required"
          :error="$v.local.municipio.$error"
          @blur="$v.local.municipio.$touch()"
          v-model="local.municipio"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6">
        <v-text-field
          dense
          outlined
          hide-details
          :disabled="hasSelectedAddress"
          autocomplete="off"
          label="Complemento"
          maxlength="60"
          v-model="local.complemento"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          dense
          outlined
          hide-details
          :disabled="hasSelectedAddress"
          autocomplete="off"
          label="Ponto de referência"
          maxlength="60"
          v-model="local.pontoReferencia"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-checkbox
          dense
          v-if="!hasSelectedAddress"
          v-model="local.favorito"
          label="Salvar endereço para futuras contratações"
        ></v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import EscolherEnderecoDialog from './EscolherEnderecoDialog.vue';

export default {
  mixins: [validationMixin],
  props: {
    local: Object,
    label: String,
    showDivider: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hasSelectedAddress: false,
    };
  },
  methods: {
    onSelectAddress(addres) {
      this.hasSelectedAddress = true;
      this.local.favorito = false;
      this.local.logradouro = addres.localFrete.logradouro;
      this.local.numero = addres.localFrete.numero;
      this.local.bairro = addres.localFrete.bairro;
      this.local.complemento = addres.localFrete.complemento;
      this.local.pontoReferencia = addres.localFrete.pontoReferencia;
      this.local.cpfCnpj = addres.localFrete.cpfCnpj;
      this.$emit('loadaddress');
    },
    onClear() {
      this.hasSelectedAddress = false;
      this.local.favorito = false;
    },
  },
  validations: {
    local: {
      cep: {
        required,
      },
      logradouro: {
        required,
      },
      bairro: {
        required,
      },
      uf: {
        required,
      },
      municipio: {
        required,
      },
    },
  },
  components: {
    pxEscolherEnderecoDialog: EscolherEnderecoDialog,
  },
};
</script>
